import React, { useMemo } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";

export default function CourseDetailPage() {
  const navigate = useNavigate();
  const { slug } = useParams();

  // ✅ Mock data (ยังไม่ต่อ DB)
  const course = useMemo(() => {
    return {
      id: "course_mock_001",
      slug: slug || "ai-automation-101",
      title: "AI Automation 101: เริ่มต้นสร้างระบบอัตโนมัติด้วย AI",
      subtitle: "คอร์สสำหรับมือใหม่ เน้นทำได้จริง พร้อมตัวอย่างงานจริง",
      level: "Beginner",
      duration: "3 ชั่วโมง",
      lessonsCount: 12,
      updatedAt: "อัปเดตล่าสุด: ม.ค. 2026",
      priceText: "฿990",
      coverUrl: "https://via.placeholder.com/1200x600?text=Course+Cover",
      whatYouGet: [
        "วิดีโอ 12 บทเรียน",
        "ไฟล์ตัวอย่าง + Checklist",
        "เข้าเรียนได้ตลอด (mock)",
        "Certificate (mock)",
      ],
      highlights: [
        "ปูพื้นฐาน Automation + Prompting",
        "Workflow ตัวอย่างสำหรับงานจริง",
        "แนวคิดการออกแบบระบบให้ขยายได้",
      ],
      curriculum: [
        { no: 1, title: "แนะนำคอร์ส + เตรียมเครื่องมือ", time: "10:12" },
        { no: 2, title: "พื้นฐาน Automation ที่ควรรู้", time: "18:40" },
        { no: 3, title: "Prompt สำหรับงานจริง", time: "22:05" },
        { no: 4, title: "Workshop: ทำ Workflow แรก", time: "31:10" },
      ],
      description:
        "คอร์สนี้เป็น mockup สำหรับคุยกับทีมงานก่อน เรายังไม่เชื่อมต่อฐานข้อมูล คุณสามารถปรับส่วนต่าง ๆ ให้ตรงกับรูปแบบของ Encraft ได้เลยครับ",
      instructor: {
        name: "ทีม Encraft",
        bio: "ดูแลเนื้อหาและพัฒนาระบบการเรียนออนไลน์ (mock)",
      },
    };
  }, [slug]);

  const onEnroll = () => {
    navigate(`/courses/${course.id}/enroll`);
  };

  const onStartLearning = () => {
    navigate(`/learn/${course.id}`);
  };

  return (
    <div className="container py-4">
      {/* breadcrumb */}
      <div className="mb-3">
        <Link to="/courses" className="text-decoration-none">
          ← กลับไปหน้าคอร์สทั้งหมด
        </Link>
      </div>

      {/* hero */}
      <div className="card overflow-hidden">
        <div className="ratio ratio-21x9 bg-light">
          <img
            src={course.coverUrl}
            alt={course.title}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>

        <div className="card-body">
          <div className="row g-4">
            {/* left */}
            <div className="col-lg-8">
              <h1 className="h3 mb-2">{course.title}</h1>
              <p className="text-secondary mb-3">{course.subtitle}</p>

              <div className="d-flex flex-wrap gap-2 mb-3">
                <span className="badge text-bg-secondary">ระดับ: {course.level}</span>
                <span className="badge text-bg-secondary">เวลา: {course.duration}</span>
                <span className="badge text-bg-secondary">บทเรียน: {course.lessonsCount}</span>
                <span className="badge text-bg-secondary">{course.updatedAt}</span>
              </div>

              <h2 className="h5 mt-4">ไฮไลต์</h2>
              <ul className="mb-4">
                {course.highlights.map((t, i) => (
                  <li key={i}>{t}</li>
                ))}
              </ul>

              <h2 className="h5">คำอธิบายคอร์ส</h2>
              <p className="text-secondary">{course.description}</p>

              <h2 className="h5 mt-4">โครงบทเรียน (ตัวอย่าง)</h2>
              <div className="list-group">
                {course.curriculum.map((l) => (
                  <div
                    key={l.no}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <div className="fw-semibold">
                        {l.no}. {l.title}
                      </div>
                      <div className="text-secondary small">เวลาโดยประมาณ</div>
                    </div>
                    <span className="badge text-bg-light border">{l.time}</span>
                  </div>
                ))}
              </div>

              <div className="mt-4">
                <h2 className="h5">ผู้สอน</h2>
                <div className="d-flex gap-3 align-items-start">
                  <div
                    className="rounded-circle bg-light border"
                    style={{ width: 48, height: 48 }}
                    aria-hidden="true"
                  />
                  <div>
                    <div className="fw-semibold">{course.instructor.name}</div>
                    <div className="text-secondary">{course.instructor.bio}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* right */}
            <div className="col-lg-4">
              <div className="card border">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="text-secondary">ราคา</div>
                    <div className="h4 mb-0">{course.priceText}</div>
                  </div>

                  <div className="text-secondary small mb-3">
                    * ยังเป็น mockup (ยังไม่เชื่อม payment/DB)
                  </div>

                  <div className="d-grid gap-2">
                    <button className="btn btn-primary" onClick={onEnroll}>
                      สมัครเรียน
                    </button>
                    <button className="btn btn-outline-secondary" onClick={onStartLearning}>
                      เริ่มเรียน (mock)
                    </button>
                  </div>

                  <hr />

                  <div className="fw-semibold mb-2">สิ่งที่คุณจะได้รับ</div>
                  <ul className="mb-0">
                    {course.whatYouGet.map((t, i) => (
                      <li key={i} className="text-secondary">
                        {t}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="alert alert-info mt-3 mb-0">
                หน้านี้เป็น mockup เพื่อคุยกับทีมงาน: คุณสามารถเปลี่ยน layout/ข้อความได้ตามต้องการ
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
